import { useEffect } from 'react'

const DEFAULT_TITLE = 'Realitní Jestřáb'
const DEFAULT_DESCRIPTION = 'Realitní Jestřáb - detail nemovitosti, cena, lokalita a fotografie.'

const Seo = ({ title, description, image, canonicalUrl, noindex = false, referrerPolicy }) => {
  const fullTitle = title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE
  const metaDescription = description || DEFAULT_DESCRIPTION

  useEffect(() => {
    if (typeof document === 'undefined') return

    const setMeta = (attr, key, content) => {
      const selector = `meta[${attr}="${key}"]`
      let tag = document.head.querySelector(selector)
      if (!content) {
        if (tag) tag.remove()
        return
      }
      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute(attr, key)
        document.head.appendChild(tag)
      }
      tag.setAttribute('content', content)
    }

    const setLink = (rel, href) => {
      const selector = `link[rel="${rel}"]`
      let tag = document.head.querySelector(selector)
      if (!href) {
        if (tag) tag.remove()
        return
      }
      if (!tag) {
        tag = document.createElement('link')
        tag.setAttribute('rel', rel)
        document.head.appendChild(tag)
      }
      tag.setAttribute('href', href)
    }

    document.title = fullTitle
    setMeta('name', 'description', metaDescription)
    setMeta('property', 'og:site_name', DEFAULT_TITLE)
    setMeta('property', 'og:title', fullTitle)
    setMeta('property', 'og:description', metaDescription)
    setMeta('property', 'og:type', 'website')
    setMeta('property', 'og:url', canonicalUrl)
    setMeta('property', 'og:image', image)
    setMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary')
    setMeta('name', 'robots', noindex ? 'noindex,nofollow' : null)
    setMeta('name', 'referrer', referrerPolicy)
    setLink('canonical', canonicalUrl)
  }, [fullTitle, metaDescription, image, canonicalUrl, noindex, referrerPolicy])

  return null
}

export default Seo
